import React from 'react';

const GOLD = '#C9A84C';

const MIXOLOGY_IMG =
  'https://customer-assets-39nsmqrw.emergentagent.net/job_chocolate-supreme-mx/artifacts/d356c57be35fa064_Gemini_Generated_Image_4sjhy14sjhy14sjh.jpg';

export default function Mixology() {
  return (
    <main style={{ background: '#0A0A0A', color: '#fff', fontFamily: 'Montserrat, sans-serif', paddingTop: '5rem' }}>

      {/* ===== TWO-COLUMN LAYOUT ===== */}
      <section
        style={{
          minHeight: 'calc(100vh - 5rem)',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          alignItems: 'stretch',
        }}
      >
        {/* IMAGE SIDE */}
        <div
          style={{
            position: 'relative',
            minHeight: '60vh',
            overflow: 'hidden',
          }}
        >
          <img
            src={MIXOLOGY_IMG}
            alt="Mixología Aura"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center',
              display: 'block',
            }}
          />
          {/* subtle gold overlay on bottom */}
          <div
            style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              height: '40%',
              background: 'linear-gradient(to top, rgba(0,0,0,0.6) 0%, transparent 100%)',
            }}
          />
        </div>

        {/* TEXT SIDE */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            padding: 'clamp(3rem, 6vw, 6rem) clamp(2rem, 5vw, 5rem)',
            background: '#0d0d0d',
            borderLeft: '1px solid rgba(201,168,76,0.1)',
          }}
        >
          {/* top line */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '2rem' }}>
            <div style={{ height: '1px', width: '2.5rem', background: GOLD }} />
            <span
              style={{
                color: GOLD,
                fontSize: '0.62rem',
                letterSpacing: '0.45em',
                textTransform: 'uppercase',
              }}
            >
              Próximamente
            </span>
          </div>

          <h1
            style={{
              fontFamily: 'Cormorant Garamond, serif',
              fontSize: 'clamp(2.4rem, 5vw, 3.8rem)',
              fontWeight: 300,
              color: '#fff',
              lineHeight: 1.1,
              marginBottom: '1.5rem',
            }}
          >
            Mixología{' '}
            <span style={{ color: GOLD, fontStyle: 'italic' }}>Aura</span>
          </h1>

          <p
            style={{
              fontSize: '0.88rem',
              color: 'rgba(255,255,255,0.5)',
              lineHeight: 1.9,
              marginBottom: '2.5rem',
              maxWidth: '34rem',
            }}
          >
            Estamos preparando una guía exclusiva de bebidas elaboradas con
            Aura Chocolate Supreme para que puedas disfrutar al máximo su sabor
            y potenciar cada experiencia. Desde preparaciones frías hasta cócteles
            calientes, aprenderás a combinar nuestro chocolate con ingredientes
            que elevan cada sorbo al siguiente nivel.
          </p>

          {/* divider */}
          <div style={{ width: '3rem', height: '1px', background: 'rgba(201,168,76,0.3)', marginBottom: '2.5rem' }} />

          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.75rem',
              padding: '0.75rem 2rem',
              border: '1px solid rgba(201,168,76,0.25)',
              color: 'rgba(201,168,76,0.55)',
              fontSize: '0.65rem',
              letterSpacing: '0.35em',
              textTransform: 'uppercase',
              alignSelf: 'flex-start',
            }}
          >
            <div
              style={{
                width: '6px',
                height: '6px',
                borderRadius: '50%',
                background: GOLD,
                opacity: 0.5,
                animation: 'pulse 2s infinite',
              }}
            />
            En desarrollo · Muy pronto
          </div>
        </div>
      </section>

    </main>
  );
}
